<template>
  <v-container grid-list-sm class="pa-0">
    <template>
      <v-layout justify-center wrap>

        <v-flex xs12 mt-5 v-if="this.badgeData.badgeId">
          <v-card>
            <v-toolbar color="primary" dark dense>
              <v-toolbar-title>{{ this.badgeData.title }}</v-toolbar-title>
            </v-toolbar>
            <v-container
              fluid
              grid-list-md
            >
              <v-layout row wrap px-0 align-start>
                <v-flex xs12 sm4>
                  <dl class="cert-details">
                    <div class="cert-detail-item">
                      <dt class="cert-detail-label">Badge Id</dt>
                      <dd class="cert-detail-value">{{ this.badgeData.badgeId }}</dd>
                    </div>
                    <div class="cert-detail-item">
                      <dt class="cert-detail-label">Date of issue</dt>
                      <dd class="cert-detail-value">{{ this.badgeData.lastIssued }}</dd>
                    </div>
                    <div class="cert-detail-item">
                      <dt class="cert-detail-label">Date of expiration</dt>
                      <dd class="cert-detail-value">{{ this.badgeData.expiresOn }}</dd>
                    </div>
                  </dl>
                </v-flex>
                <v-flex xs12 sm8>
                  <div class="cert-thumbs">
                    <div class="cert-thumb" @click="imagePreviewSrc = frontImg">
                      <v-img :src="this.frontImg" aspect-ratio="1.6" contain/>
                    </div>
                    <div class="cert-thumb" @click="imagePreviewSrc = certImg">
                      <v-img :src="this.certImg" aspect-ratio="1.6" contain/>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <div v-if="loadingCertificates"><v-img class="pa-5">
          <v-progress-circular indeterminate color="blue lighten-2"></v-progress-circular>
        </v-img></div>

        <v-flex v-if="loadingCertificates === false"
                xs12 mt-5 v-for="certificate in allCertificates" :key="certificate.id+certificate.name">
          <v-card :key="certificate.id+certificate.name">
            <v-toolbar color="primary" dark dense>
              <v-toolbar-title>{{ certificate.name }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="editCertificate(certificate)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-container
              fluid
              grid-list-md
            >
              <v-layout row wrap px-0 align-start>
                <v-flex xs12 sm4>
                  <dl class="cert-details">
                    <div class="cert-detail-item">
                      <dt class="cert-detail-label">Type</dt>
                      <dd class="cert-detail-value">{{ certificate.type || '—' }}</dd>
                    </div>
                    <div class="cert-detail-item">
                      <dt class="cert-detail-label">Date of issue</dt>
                      <dd class="cert-detail-value">{{ formatDate(certificate.issueDate) }}</dd>
                    </div>
                    <div class="cert-detail-item">
                      <dt class="cert-detail-label">Date of expiration</dt>
                      <dd class="cert-detail-value">{{ formatDate(certificate.expiryDate) }}</dd>
                    </div>
                  </dl>
                </v-flex>
                <v-flex xs12 sm8>
                  <div class="cert-thumbs">
                    <div v-if="certificate.file1" class="cert-thumb"
                         @click="imagePreviewSrc = certificate.file1">
                      <v-img :src="certificate.file1" aspect-ratio="1.6" contain/>
                    </div>
                    <div v-if="certificate.file2" class="cert-thumb"
                         @click="imagePreviewSrc = certificate.file2">
                      <v-img :src="certificate.file2" aspect-ratio="1.6" contain/>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <v-flex xs12 mt-5>
          <v-btn
            color="primary"
            block
            @click="showAddNewCertificateDialog"
            :disabled="loadingCertificates"
          >
            <v-icon right dark>add</v-icon>
            Add new certificate
          </v-btn>
        </v-flex>

        <v-flex xs12 mt-5>
            <v-dialog
              v-model="addNewCertDialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
              scrollable
            >

                <v-card>
                  <v-toolbar card dark color="primary">
                    <v-toolbar-title v-if="selectedCertificateId === 0"> <v-icon>add</v-icon> Add new certificate</v-toolbar-title>
                    <v-toolbar-title v-if="selectedCertificateId !== 0">Update certificate</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn icon dark @click="addNewCertDialog = false">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>

                  <v-container fluid grid-list-md>
                    <v-layout row wrap px-0 justify-center>
                      <div class="cert-form-wrap pa-0 grid-list-sm">

                        <v-flex class="justify-self-end">
                          <a @click="certificateHelpDialog = true" href="#">Show me where to find certificate name, type, issuer</a>
                        </v-flex>
                        <v-flex>
                          <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation
                          >
                            <v-layout row>
                              <v-flex xs1 class="number">
                                1.
                              </v-flex>
                              <v-flex xs11>
                                <v-text-field
                                  v-model="certificateName"
                                  label="Certificate Name"
                                  v-validate="'required'"
                                  data-vv-scope="slot1"
                                  data-vv-name="slot1.certificateName"
                                  :error-messages="errors.collect('slot1.certificateName')"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <v-flex xs1 class="number">
                                2.
                              </v-flex>
                              <v-flex xs11>
                                <div style="font-size: 16px;color: gray;margin-top: 16px;">Certificate Type</div>
                                <v-radio-group v-model="certificateType" @change="updateIssuers" row style="margin-top: 0">
                                  <v-radio
                                    v-for="n in ['Food Handler', 'Food Manager']"
                                    :key="n"
                                    :label="n"
                                    :value="n"
                                  ></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <v-flex xs1 class="number">
                                3.
                              </v-flex>
                              <v-flex xs11>
                                <v-select
                                  :items="certificateIssuers"
                                  v-model="certificateIssuer"
                                  label="Certificate Issuer"
                                  v-validate="'required'"
                                  data-vv-scope="slot1"
                                  data-vv-name="slot1.certificateIssuer"
                                  :error-messages="errors.collect('slot1.certificateIssuer')"
                                ></v-select>
                              </v-flex>
                            </v-layout>


                            <v-layout row>
                              <v-flex xs1 class="number">
                                4.
                              </v-flex>
                              <v-flex xs5>
                                <v-dialog
                                  ref="dialog1"
                                  v-model="issueDateModal"
                                  :return-value.sync="issueDate"
                                  persistent
                                  lazy
                                  full-width
                                  width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-model="issueDate"
                                      label="Issue Date"
                                      prepend-icon="event"
                                      v-validate="'required'"
                                      data-vv-scope="slot1"
                                      data-vv-name="slot1.issueDate"
                                      :error-messages="errors.collect('slot1.issueDate')"
                                      readonly
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker v-model="date" :max="minDate"scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="issueDateModal = false">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="$refs.dialog1.save(date)">OK</v-btn>
                                  </v-date-picker>
                                </v-dialog>
                              </v-flex>
                              <v-flex xs6>
                                <v-dialog
                                  ref="dialog"
                                  v-model="expiryDateModal"
                                  :return-value.sync="expiryDate"
                                  persistent
                                  lazy
                                  full-width
                                  width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-model="expiryDate"
                                      label="Expiry Date"
                                      prepend-icon="event"
                                      readonly
                                      v-on="on"
                                      v-validate="'required'"
                                      data-vv-scope="slot1"
                                      data-vv-name="slot1.expiryDate"
                                      :error-messages="errors.collect('slot1.expiryDate')"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker v-model="maxDate"
                                                 :min="maxDate"
                                                 scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="expiryDateModal = false">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="$refs.dialog.save(maxDate)">OK</v-btn>
                                  </v-date-picker>
                                </v-dialog>
                              </v-flex>
                            </v-layout>


                            <v-layout row wrap>
                              <v-flex xs1 sm1 class="number">
                                5.
                              </v-flex>
                              <v-flex xs11 sm5>
                                <v-input
                                  prepend-icon="upload_file"
                                  v-model="certificateImage1"
                                  v-validate="'required'"
                                  data-vv-scope="slot1"
                                  data-vv-name="slot1.certificateImage1"
                                  :error-messages="errors.collect('slot1.certificateImage1')"
                                  style="align-items: center;"
                                ><div class="pt-4" style="align-items: center;">
                                  <img :src="certificateImage1"
                                       @click="imagePreviewSrc = certificateImage1"
                                       v-if="certificateImage1" alt="certificate" height="100">
                                  <v-progress-circular
                                    v-if="isBtn1Disabled"
                                    :size="20"
                                    :width="2"
                                    color="primary"
                                    indeterminate
                                  ></v-progress-circular>
                                  <upload-certificate-button
                                    :disabled="isBtn1Disabled"
                                    title="Upload certificate front"
                                    :selectedCallback="(e) => uploadImage(e, 'file1')"/>
                                </div>
                                </v-input>
                              </v-flex>
                              <v-flex xs11 sm6 offset-xs1 offset-sm0>
                                <v-input
                                  prepend-icon="upload_file"
                                  style="align-items: center;"
                                ><div class="pt-4" style="align-items: center;">

                                  <div style="display: flex;align-items: center;">
                                    <img :src="certificateImage2"
                                         @click="imagePreviewSrc = certificateImage2"
                                         v-if="certificateImage2" alt="certificate" height="100">
                                    <v-btn
                                      @click="clearCertificateImage2" v-if="certificateImage2"
                                      color="error"
                                      flat icon
                                    >
                                      <v-icon dark>delete</v-icon>
                                    </v-btn>
                                  </div>
                                  <v-progress-circular
                                    v-if="isBtn2Disabled"
                                    :size="20"
                                    :width="2"
                                    color="primary"
                                    indeterminate
                                  ></v-progress-circular>
                                  <upload-certificate-button
                                    :disabled="isBtn2Disabled"
                                    title="Upload certificate back (optional)"
                                    :selectedCallback="(e) => uploadImage(e, 'file2')"/>

                                </div>
                                </v-input>
                              </v-flex>
                            </v-layout>

                            <v-divider class="mt-4 mb-3"></v-divider>

                            <v-layout class="form-actions" row wrap justify-end>
                              <v-btn
                                color="secondary"
                                flat
                                class="action-btn"
                                @click="addNewCertDialog = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                :loading="loading"
                                color="primary"
                                class="action-btn"
                                @click="validate"
                              >
                                {{ selectedCertificateId === 0 ? 'Submit' : 'Update'}}
                              </v-btn>
                            </v-layout>

                          </v-form>
                        </v-flex>

                      </div>
                    </v-layout>
                  </v-container>
                </v-card>


            </v-dialog>



        </v-flex>
      </v-layout>
    </template>

    <v-dialog v-model="certificateHelpDialog"
              persistent
              width="500">
      <v-toolbar card dark color="primary">
        <v-toolbar-title>Certificate examples</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="certificateHelpDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-container grid-list-sm fluid>
          <v-layout row wrap>
            <v-flex
              v-for="n in certImages"
              :key="n"
              xs12
              d-flex
            >
              <v-card class="mb-2">
                <v-img
                  :src="n"
                  @click="imagePreviewSrc = n"
                  :lazy-src="n"
                >
                  <template v-slot:placeholder>
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="imagePreviewSrc"
              v-if="imagePreviewSrc"
              width="500"
              transition="dialog-bottom-transition">
      <v-card>
        <v-card-text>
          <img :src="imagePreviewSrc" style="width: inherit" alt="Image Preview"/>
        </v-card-text>
        <v-card-actions>
          <v-btn dark flat
                 color="info"
                 @click="downloadResizedImage (imagePreviewSrc, 500, 500, Date.now() + '.png')">
            <v-icon>cloud_download</v-icon>
            &nbsp;Download

          </v-btn>
          <v-spacer></v-spacer>
          <v-btn dark flat
                 color="error"
                 @click="imagePreviewSrc = ''">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<script>
import UploadButton from '../widgets/UploadButton.vue'
import UploadCertificateButton from '../widgets/UploadCertificateButton.vue'
import VeeValidate from 'vee-validate'
import Vue from 'vue'
Vue.use(VeeValidate)
const foodHandlerIssuer = [
  '1 AAA Food Handler',
  '123 Premier Food Safety',
  'A Plus Food Training L.L.C.',
  'ACE Food Handler',
  'Altametrics',
  'Certus aka StateFoodSafety',
  'Cogneti LLC',
  'DSBWorldWide aka EduClasses®',
  'eFoodTrainer Inc.',
  'FARE (Food Allergy Research and Education)',
  'Food Handler Solutions LLC',
  'Food Service Prep',
  'FoodSafePal',
  'Home of Training, Inc.',
  'Institute of Food Safety, Health, & Hygiene, Inc.',
  'Learn2Serve',
  'MenuTrinfo, LLC',
  'National Environmental Health Association',
  'National Registry of Food Safety Professionals®',
  'ServSafe aka National Restaurant Association Solutions',
  'Relish Works, Inc. aka Trust20',
  'Responsible Training / Safeway Certifications, LLC',
  'Rserving',
  'TAP Series',
  'The Always Food Safe Company, LLC',
  'Userve'
]

const foodProtectionManagerIssuer = [
  'AAA Trainers Inc. aka AAA Food Handler',
  'APS Culinary Dynamics (DBA: World Food Safety Organization)',
  'StateFoodSafety aka Certus',
  'DSBWorldWide, Inc aka EduClasses®',
  'Learn2Serve',
  'My Food Service License',
  'National Registry of Food Safety Professionals',
  'ServSafe® aka National Restaurant Association Solutions',
  'Relish Works, Inc. (DBA: Trust20)',
  'Responsible Training / Safeway Certifications, LLC',
  'The Always Food Safe Company, LLC',
  'Userve'
]

const certImages = [
  require('@/assets/images/CaliforniaFoodHandler.png'),
  require('@/assets/images/StateFoodSafety.png'),
  require('@/assets/images/ServSafe.png')
]

export default {
  name: 'MyCertificates',
  components: {UploadCertificateButton, UploadButton},
  data: () => ({
    allCertificates: [],
    certImages: certImages,
    selectedCertificateId: 0,
    loadingCertificates: false,
    certificateHelpDialog: false,
    isBtn2Disabled: false,
    isBtn1Disabled: false,
    date: new Date().toISOString().substr(0, 10),
    minDate: new Date(Date.now()).toISOString().split('T')[0],
    maxDate: new Date().toISOString().substr(0, 10),
    issueDateModal: false,
    expiryDateModal: false,
    valid: true,
    addNewCertDialog: false,
    certificateName: '',
    certificateType: 'Food Handler',
    certificateIssuers: foodHandlerIssuer,
    certificateIssuer: '',
    issueDate: '',
    expiryDate: '',
    // certificateImage1: 'https://api.cogneti.com/ws/userservice/user/14617/certificate/1736171804_14617/png',
    certificateImage1Name: null,
    certificateImage1: null,
    certificateImage2Name: null,
    certificateImage2: null,
    dictionary: {
      custom: {
        'slot1.certificateName': {
          required: () => 'Certificate name is required'
        },
        'slot1.certificateType': {
          required: () => 'Certificate type is required'
        },
        'slot1.issueDate': {
          required: () => 'Issue date  is required'
        },
        'slot1.expiryDate': {
          required: () => 'Expiry date  is required'
        },
        'slot1.certificateImage1': {
          required: () => 'Front side of certificate is required'
        },
        'slot1.certificateIssuer': {
          required: () => 'Certificate issuer is required'
        }
      }
    },
    loading: false,
    image: '',
    frontImg: '',
    certImg: '',
    badgeData: {},
    apiUrl: process.env.API_URL,
    courseId: process.env.GAME_ID,
    isFormValidated: false,
    imagePreviewSrc: ''
  }),
  computed: {
    user () {
      return this.$store.getters['user/getUserDetails']
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
  },
  created () {
    this.getSelectedUser()
    this.getCertificates()
    // eslint-disable-next-line no-console
    // console.log(this.replaceLastSlashWithDot('/ws/userservice/user/14617/certificate/1736264977_14617/png'))
  },
  methods: {
    downloadResizedImage (base64Src, maxWidth, maxHeight, filename = 'resized_image.png') {
      const img = new Image()
      img.src = base64Src
      img.onload = () => {
        // Calculate the new dimensions
        let width = img.width
        let height = img.height

        if (width > height) {
          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width)
            width = maxWidth
          }
        } else {
          if (height > maxHeight) {
            width = Math.round((width * maxHeight) / height)
            height = maxHeight
          }
        }

        // Create a canvas to resize the image
        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext('2d')

        // Draw the resized image
        ctx.drawImage(img, 0, 0, width, height)

        // Convert canvas to base64 image and trigger download
        const resizedBase64 = canvas.toDataURL('image/png')
        const link = document.createElement('a')
        link.href = resizedBase64
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }

      img.onerror = (err) => {
        console.error('Failed to load image:', err)
      }
    },
    clearCertificateImage2 () {
      this.certificateImage2 = null
      this.certificateImage2Name = null
    },
    updateIssuers (issuer) {
      this.certificateIssuer = ''
      if (issuer === 'Food Handler') {
        this.certificateIssuers = foodHandlerIssuer
      } else {
        this.certificateIssuers = foodProtectionManagerIssuer
      }
    },
    resetForm () {
      this.selectedCertificateId = 0
      this.certificateName = ''
      this.certificateIssuer = ''
      this.certificateType = 'Food Handler'
      this.issueDate = ''
      this.expiryDate = ''
      this.certificateImage1 = null
      this.certificateImage1Name = null
      this.certificateImage2 = null
      this.certificateImage2Name = null
      this.isBtn1Disabled = false
      this.isBtn2Disabled = false
    },
    async editCertificate (certificate) {
      // eslint-disable-next-line no-console
      console.log('edit certificate', certificate)
      this.isBtn1Disabled = false
      this.isBtn2Disabled = false
      this.selectedCertificateId = certificate.id
      this.certificateIssuer = certificate.issuer
      this.certificateName = certificate.name
      this.certificateType = certificate.type
      this.certificateType = certificate.type
      this.issueDate = certificate.issueDate.split('T')[0]
      this.expiryDate = certificate.expiryDate.split('T')[0]
      this.certificateImage1Name = certificate.file1Name ? this.replaceLastSlashWithDot(certificate.file1Name) : null
      this.certificateImage2Name = certificate.file2Name ? this.replaceLastSlashWithDot(certificate.file2Name) : null
      this.certificateImage1 = certificate.file1 ? certificate.file1 : null
      this.certificateImage2 = certificate.file2 ? certificate.file2 : null
      this.addNewCertDialog = true
    },
    formatDate (isoDate) {
      const date = new Date(isoDate)
      const options = { year: 'numeric', month: 'short', day: 'numeric' }
      return date.toLocaleDateString('en-US', options)
    },
    showAddNewCertificateDialog () {
      this.addNewCertDialog = true
      this.resetForm()
      this.errors.clear('slot1')
      this.$validator.reset()
    },
    validate () {
      this.$validator.validateAll('slot1').then((result) => {
        const data = {
          type: this.certificateType,
          name: this.certificateName,
          issuer: this.certificateIssuer,
          issueDate: this.issueDate,
          expiryDate: this.expiryDate,
          file1: this.certificateImage1Name,
          file2: this.certificateImage2Name
        }
        if (this.selectedCertificateId) {
          data.id = this.selectedCertificateId
        }
        if (result === true) {
          this.loading = true
          this.$http({
            url: `${this.apiUrl}/ws/userservice/user/${this.user.id}/certificate`,
            method: this.selectedCertificateId ? 'PUT' : 'POST',
            headers: {
              Authorization: 'Bearer ' + this.$auth.token(),
              'Content-Type': 'application/json'
            },
            data
          }).then((res) => {
            if (this.selectedCertificateId) {
              this.$store.commit('flashSuccess', 'Certificate updated successfully')
            } else {
              this.$store.commit('flashSuccess', 'Certificate added successfully')
            }
            this.loading = false
            this.addNewCertDialog = false
            this.getCertificates()
          }, (err) => {
            this.$store.dispatch('apiError', {errorObj: err, customMsg: 'Unable to process your request'})
            this.loading = false
          })
        } else {
          this.loading = false
          // this.$store.commit('flashError', 'Please fix all errors')
        }
      })
    },
    getSelectedUser () {
      if (this.$store.getters['course/getBadgeScore'] > 0) {
        this.frontImg = ''
        this.certImg = ''
        this.$store.dispatch('complianceProgram/fetchUser', {
          courseId: this.courseId,
          username: this.user.email
        }).then(response => {
          this.$store.dispatch('course/fetchBadgeData', {deckId: this.courseId, userId: this.user.id}).then(badge => {
            this.badgeData = badge.data
            this.$store.dispatch('exam/fetchBadgeFrontImage', {
              deckId: this.courseId,
              userId: this.user.id
            }).then(data => {
              let prefix = 'data:' + data.headers['content-type'] + ';base64,'
              let img = Buffer.from(data.data, 'binary').toString('base64')
              this.frontImg = prefix + img
            }).catch(err => {
              console.error('fetchBadgeFrontImageNew', err)
            })
            this.$store.dispatch('exam/fetchCertificateImage', {
              deckId: this.courseId,
              userId: this.user.id
            }).then(data => {
              let prefix = 'data:' + data.headers['content-type'] + ';base64,'
              let img = Buffer.from(data.data, 'binary').toString('base64')
              this.certImg = prefix + img
            }).catch(err => {
              console.error('fetchBadgeFrontImageNew', err)
            })
          })
        })
      }
    },
    replaceLastSlashWithDot (input) {
      let lastDotIndex = input.lastIndexOf('/')
      if (lastDotIndex !== -1) {
        input = input.substring(0, lastDotIndex) + '.' + input.substring(lastDotIndex + 1)
      }
      return input.split('/').pop()
    },
    replaceLastDotWithSlash (input) {
      let lastDotIndex = input.lastIndexOf('.')
      if (lastDotIndex !== -1) {
        input = input.substring(0, lastDotIndex) + '/' + input.substring(lastDotIndex + 1)
      }
      return input
    },
    async uploadImage (event, name) {
      const file = event.target.files[0]
      // eslint-disable-next-line no-console
      // console.log('file', file)
      const selectedFile = event.target.files[0]
      const formData = new FormData()
      // formData.append('image', selectedFile)
      formData.append(file.name, selectedFile)
      if (name === 'file1') {
        this.isBtn1Disabled = true
      }
      if (name === 'file2') {
        this.isBtn2Disabled = true
      }
      try {
        const response = await this.$http({
          url: `${this.apiUrl}/ws/userservice/user/${this.user.id}/certificate/file`,
          headers: {
            Authorization: 'Bearer ' + this.$auth.token(),
            'Content-Type': 'multipart/form-data'
          },
          method: 'POST',
          data: formData
        })
        const fileName = this.replaceLastDotWithSlash(response.data)
        const filePath = `${this.apiUrl}/ws/userservice/user/${this.user.id}/certificate/${fileName}`

        if (name === 'file1') {
          this.certificateImage1 = await this.getImage(filePath)
          this.certificateImage1Name = response.data
          this.isBtn1Disabled = false
        }
        if (name === 'file2') {
          this.certificateImage2 = await this.getImage(filePath)
          this.certificateImage2Name = response.data
          this.isBtn2Disabled = false
        }
      } catch (error) {
        console.error('Error uploading image:', error)
      }
    },
    async getCertificates () {
      this.loadingCertificates = true
      try {
        const response = await this.$http({
          url: `${this.apiUrl}/ws/userservice/user/${this.user.id}/certificate`,
          headers: {
            Authorization: 'Bearer ' + this.$auth.token()
            // 'Content-Type': 'multipart/form-data'
          },
          method: 'GET'
        })

        const certs = await Promise.all(response.data.map(async d => {
          const cert = {
            ...d,
            file1Name: d.file1,
            file2Name: d.file2,
            file1: await this.getImage(this.apiUrl + d.file1)
          }
          if (d.file2) {
            cert.file2 = await this.getImage(this.apiUrl + d.file2)
          } else {
            cert.file2 = null
          }
          return cert
        }))

        this.loadingCertificates = false
        // eslint-disable-next-line no-console
        console.log('certs', certs)
        this.allCertificates = certs
      } catch (error) {
        console.error('Error fetching certificates:', error)
      }
    },
    async getImage (url) {
      // eslint-disable-next-line no-console
      console.log('Getting')
      try {
        const data = await this.$http({
          url,
          headers: {
            Authorization: 'Bearer ' + this.$auth.token()
            // 'Content-Type': 'multipart/form-data'
          },
          responseType: 'arraybuffer',
          method: 'GET'
        })
        // eslint-disable-next-line no-console
        // console.log('DATA', data)
        // console.log('DATA headers', data.headers)
        // const imageObjectURL = URL.createObjectURL(data)
        let prefix = 'data:' + data.headers['content-type'] + ';base64,'
        let img = Buffer.from(data.data, 'binary').toString('base64')

        return prefix + img
        // this.image = imageObjectURL
        // console.log('Certificates:', response.data)
      } catch (error) {
        console.error('Error uploading image:', error)
      }
    }
  }
}
</script>



<style scoped>
  .number {
    align-content: center;font-size: 1.25rem;padding-right: 0;text-align: center;
  }
  .cert-details {
    margin: 0;
    padding: 4px 0;
    /* Auto-adapts: 2 columns on a wide (mobile full-width) container,
       collapses to 1 column inside the narrow desktop sidebar column. */
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 12px 16px;
  }
  .cert-details dt,
  .cert-details dd {
    margin: 0;
  }
  .cert-detail-label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: rgba(0, 0, 0, 0.54);
  }
  .cert-detail-value {
    font-size: 15px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
    line-height: 1.3;
    margin-top: 2px;
  }
  .cert-thumbs {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
  .cert-thumb {
    flex: 1 1 0;
    min-width: 140px;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    overflow: hidden;
    background: #fafafa;
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
  }
  .cert-thumb:hover {
    border-color: rgba(0, 0, 0, 0.24);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  }
  /* On phones give the details a little breathing room below the title
     and keep the two thumbnails side by side rather than stacked full-width. */
  @media (max-width: 599px) {
    .cert-details {
      margin-bottom: 4px;
    }
  }
  .cert-form-wrap {
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
  }
  .form-actions .action-btn {
    min-width: 140px;
  }
  @media (max-width: 599px) {
    .form-actions .action-btn {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/auth/MyCertificates.vue